import EditIcon from "@mui/icons-material/Edit";
import React from "react";
import type { MenuOptionType } from "../../../../../controls";
import type { EmailTopic } from "../../models/EmailTopic";

type Props = {
	editEmailTopic: (topic: EmailTopic) => void;
};

export const useEmailTopicsOptionsFunctions = ({ editEmailTopic }: Props) => {
	const getMenuOptions = (data?: EmailTopic) => {
		let options: MenuOptionType[] = [];

		if (!data) {
			return options;
		}

		options = options.concat([
			{
				name: "Edit Email Topics",
				key: "edit_email_topics",
				onClick: () => {
					editEmailTopic(data);
				},
				icon: <EditIcon />,
			},
		]);

		return options;
	};

	return { getMenuOptions };
};
